export const appName = 'marketing_sites';
